import { BaseQueryApi } from '@reduxjs/toolkit/query';
import Config from 'react-native-config';

type MaybePromise<T> = T | PromiseLike<T>;

let API_URL = Config.API_URL || 'https://api-test.mehir.app/';
let PREPARE_HEADERS: (
  headers: Headers,
  api: Pick<BaseQueryApi, 'getState' | 'extra' | 'endpoint' | 'type' | 'forced'>
) => MaybePromise<Headers>;

export const configureApi = (
  apiUrl: string,
  prepareHeaders: (
    headers: Headers,
    api: Pick<
      BaseQueryApi,
      'getState' | 'extra' | 'endpoint' | 'type' | 'forced'
    >
  ) => MaybePromise<Headers>
) => {
  API_URL = apiUrl;
  PREPARE_HEADERS = prepareHeaders;
};

export const getBaseUrl = () => API_URL;
export const getPrepareHeaders = () => PREPARE_HEADERS;
